export const emitBuilderPageVisit = (emit, { track, trackType } = {}) => {
  if (!track) {
    return;
  }

  emit('builderPageVisited', {
    pageName: track,
    campaignType: trackType || 'Generic'
  });
};
